// Check if query param has search definition.
export const isFromSearch = (router) => {
  if (router.query.ref && router.query.ref === 'haku') {
    return true
  }

  return false
}

export default {
  isFromSearch,
}
